import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  Switch,
  Tooltip,
} from "@mui/material";
import SweetAlertModal from "../../components/SweetAlertModal/SweetAlertModal";
import Cancel from "./../../../assets/icons/close.png";
import axios from "axios";
import { toast } from "react-toastify";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

function EditMenuDelivery({
  open,
  onClose,
  CombinedMenuList,
  menuType,
  onHandleAddItem,
}) {
  const [menuToggles, setMenuToggles] = useState([]);
  const [initialMenuToggles, setInitialMenuToggles] = useState([]);
  const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] =
    useState(false);
  const apiAddress = process.env.REACT_APP_SECRET;

  console.log(CombinedMenuList);
  console.log("menuType", menuType);

  useEffect(() => {
    if (CombinedMenuList && CombinedMenuList.length > 0) {
      const initialToggles = CombinedMenuList.map((menu) => {
        const menuTypes = menuType[menu.id] || [];

        // Check Types
        const hasDeliveryType = menuTypes.some(
          (type) => type.title === "Delivery" || type.title === "Collection",
        );

        // Check if it is SPECIFICALLY the 'Collection' type (and NOT 'Delivery')
        // If it has BOTH, we want full control, so isStrictCollection is false.
        const hasCollectionType = menuTypes.some(
          (type) => type.title === "Collection",
        );
        const hasOnlyCollectionType =
          hasCollectionType && !menuTypes.some((t) => t.title === "Delivery");

        // Determine Lock Status
        // We lock the controls ONLY if it is strictly 'Collection' (no Delivery option available)
        // OR if the restaurant itself forces Collection Only.
        const isLocked =
          hasOnlyCollectionType || menu.restaurantIsCollectionOnly;

        return {
          id: menu.id,
          menuName: menu.menuName,
          hasDeliveryType,

          // Set Initial States based on Rules
          // Rule: Always ON if it has Delivery or Collection type
          isDelivery:
            menu.restaurantIsDelivery && hasDeliveryType ? true : false,

          // Rule: ON if it is strictly Collection type or Restaurant forces it
          isCollectionOnly: isLocked ? true : menu.isCollectionOnly,

          // Flags for UI disabling
          isLocked: isLocked,

          restaurantIsDelivery: menu.restaurantIsDelivery,
          restaurantIsCollectionOnly: menu.restaurantIsCollectionOnly,
        };
      });

      setMenuToggles(initialToggles);
      setInitialMenuToggles(initialToggles);
    }
  }, [CombinedMenuList, menuType]);

  console.log("menuToggles", menuToggles);

  // Check if there are any unsaved changes
  const hasChanges = () => {
    return JSON.stringify(menuToggles) !== JSON.stringify(initialMenuToggles);
  };

  const handleToggle = (id, field) => {
    setMenuToggles((prevToggles) =>
      prevToggles.map((menu) => {
        if (menu.id === id) {
          // Safety Check 1: If the restaurant doesn't allow delivery, do nothing
          if (!menu.restaurantIsDelivery && field === "isDelivery") {
            toast.error("Restaurant product is not deliverable.", {
              position: "top-right",
              autoClose: 5000,
            });
            return menu;
          }

          // Safety Check 2: If the item is LOCKED (e.g., Strictly Collection), prevent changes
          if (menu.isLocked) {
            toast.info("Settings are locked by Menu Type.", {
              position: "top-right",
            });
            return menu;
          }

          // Standard Toggle Logic
          let updatedMenu = { ...menu, [field]: !menu[field] };

          // Optional: If you want toggling OFF Delivery to also turn OFF Collection Only:
          if (field === "isDelivery" && !updatedMenu.isDelivery) {
            updatedMenu.isCollectionOnly = false;
          }

          return updatedMenu;
        }
        return menu;
      }),
    );
  };

  const handleUpdate = async () => {
    try {
      for (const menu of menuToggles) {
        const url = `${apiAddress}/api/Menu/UpdateMenuIsDelivery?menuId=${menu.id}`;
        const payload = {
          menuId: menu.id,
          isDelivery: menu.isDelivery,
          isCollectionOnly: menu.isCollectionOnly,
        };

        await axios.put(url, payload);
      }

      toast.success("Successfully Updated!", {
        position: "top-right",
        autoClose: 5000,
      });
      setInitialMenuToggles(menuToggles); // Update initial state after successful update
      onHandleAddItem(false);
      onClose();
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Update failed. Please try again.", {
        position: "top-right",
        autoClose: 5000,
      });
    }
  };

  const resetState = () => {
    setMenuToggles(initialMenuToggles); // Reset to initial values
    onClose();
  };

  const handleClose = () => {
    if (hasChanges()) {
      setopenMenuCloseConfirmaitonModal(true);
    } else {
      resetState();
    }
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
      <SweetAlertModal
        headerText="Do you want to leave without saving?"
        bodyText="All changes made will be lost"
        open={openMenuCloseConfirmaitonModal}
        onyes={() => {
          setopenMenuCloseConfirmaitonModal(false);
          resetState();
        }}
        close={() => setopenMenuCloseConfirmaitonModal(false)}
        id={2}
      />

      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <span style={{ color: "#2a7fd4" }}>GoTaste - Edit Delivery</span>
          <Grid item xs={6}>
            <DialogActions>
              <Button onClick={handleClose}>
                <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
              </Button>
            </DialogActions>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
        <Grid container spacing={2} sx={{ padding: "0.5rem" }}>
          <Grid item xs={12} sx={{ paddingBottom: "1rem", marginTop: "1rem" }}>
            {menuToggles.map((menu) => (
              <div key={menu.id}>
                <Grid container alignItems="center">
                  <Typography fontSize={16} sx={{ paddingTop: "0.5rem" }}>
                    <h6>{menu.menuName}</h6>
                  </Typography>

                  {!menu.hasDeliveryType && (
                    <Tooltip
                      title="This item is 'In-Store' only. Select 'Delivery' or 'Collection' type to enable."
                      arrow
                    >
                      <InfoOutlinedIcon
                        sx={{
                          color: "red",
                          marginLeft: "8px",
                          fontSize: "18px",
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                  )}
                </Grid>

                <Grid
                  container
                  alignItems="center"
                  sx={{ paddingTop: "0.5rem" }}
                >
                  <Grid
                    item
                    xs={5}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <Typography fontSize={16}>Is Deliverable</Typography>
                    <Tooltip
                      title={
                        !menu.restaurantIsDelivery
                          ? "Restaurant product is not deliverable."
                          : ""
                      }
                      arrow
                    >
                      <span>
                        <Switch
                          checked={menu.isDelivery}
                          onChange={() => handleToggle(menu.id, "isDelivery")}
                          size="small"
                          disabled={
                            !menu.hasDeliveryType ||
                            !menu.restaurantIsDelivery ||
                            menu.isLocked
                          }
                        />
                      </span>
                    </Tooltip>
                  </Grid>
                </Grid>

                {menu.isDelivery && menu.restaurantIsDelivery && (
                  <Grid
                    container
                    alignItems="center"
                    sx={{ paddingLeft: "2rem", marginTop: "0.5rem" }}
                  >
                    <Grid
                      item
                      xs={4}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <Typography fontSize={16}>Collection Only</Typography>
                      <Tooltip
                        title={
                          menu.restaurantIsCollectionOnly
                            ? "Restaurant is collection only."
                            : ""
                        }
                        arrow
                      >
                        <span>
                          <Switch
                            checked={menu.isCollectionOnly}
                            onChange={() =>
                              handleToggle(menu.id, "isCollectionOnly")
                            }
                            size="small"
                            disabled={
                              menu.isLocked || menu.restaurantIsCollectionOnly
                            }
                          />
                        </span>
                      </Tooltip>
                    </Grid>
                  </Grid>
                )}
              </div>
            ))}
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
        <Button color="primary" onClick={handleUpdate}>
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditMenuDelivery;
